import { useEffect } from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { Toaster } from 'react-hot-toast'
import { useAppDispatch, useAppSelector } from '@state/hooks'
import { validateToken } from '@state/slices/authSlice'
import { ThemeProvider } from '@contexts/ThemeContext'
import MainLayout from '@components/MainLayout_v2'
import DataManagerLayout from './pages/DataManagerLayout'
import PortfolioDashboard from './pages/PortfolioDashboard'
import HelpPage from './pages/HelpPage'
import SettingsPage from './pages/SettingsPage'
import { HelpProvider } from '@components/help/HelpContext'
import { GlobalHelpPanel } from '@components/help/HelpPanel'
import OnboardingWizardHost from '@components/onboarding/OnboardingWizardHost'
import './App.css'

function App() {
  const dispatch = useAppDispatch()
  const { isAuthenticated, loading } = useAppSelector((state) => state.auth)

  useEffect(() => {
    // A real JWT in the URL (from Flask login or manual injection) always wins,
    // so a freshly-issued token from the login flow supersedes any stored token.
    const urlParams = new URLSearchParams(window.location.search)
    const urlToken = urlParams.get('token')

    if (urlToken) {
      dispatch(validateToken(urlToken))
      window.history.replaceState({}, document.title, window.location.pathname)
      return
    }

    const storedToken = localStorage.getItem('jwt_token')
    if (storedToken) {
      dispatch(validateToken(storedToken))
    } else {
      dispatch(validateToken('none')).catch(() => {})
    }
  }, [dispatch])

  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner"></div>
        <p>Loading Causeway...</p>
      </div>
    )
  }

  if (!isAuthenticated) {
    return (
      <div className="auth-error-container">
        <h1>Authentication Required</h1>
        <p>Please login first at the login page.</p>
        <a href={import.meta.env.VITE_AUTH_URL || "http://127.0.0.1:5000"}>Go to Login</a>
      </div>
    )
  }

  return (
    <>
      <Toaster position="top-right" />
      <BrowserRouter>
        <ThemeProvider>
          <HelpProvider>
            <Routes>
              <Route path="/" element={<MainLayout />} />
              <Route path="/data-manager" element={<DataManagerLayout />} />
              <Route path="/portfolio" element={<PortfolioDashboard />} />
              <Route path="/help" element={<HelpPage />} />
              <Route path="/settings" element={<SettingsPage />} />
            </Routes>
            <GlobalHelpPanel />
            <OnboardingWizardHost />
          </HelpProvider>
        </ThemeProvider>
      </BrowserRouter>
    </>
  )
}

export default App
